<template>
  <a-card :bordered="false">
    <!-- 头部 -->
    <div class="top">
      <div class="head">
        <h1><a href="#"><img src="@/assets/logo.png"></a></h1>
      </div>
    </div>
    <!-- 头部-END -->
    <div class="topimg">
      <img src="@/assets/banner2.png" alt="Image" />
    </div>

<div class="newbox">
    <div class="table-page-search-wrapper search">
        <a-form layout="inline">
          <a-row class="nantrow" :gutter="48">
            <a-col class="ncol" :md="8" :sm="12" :xs="24">
                <span style="display: flex;width:60px">年份</span>
                  <a-date-picker
                      valueFormat="YYYY-MM-DD"
                      mode="year"
                      placeholder="请选择年份"
                      format="YYYY"
                      :allowClear="false"
                      v-model="queryParams.year"
                      style="width:100%"
                      :open="yearShowOne"
                      @openChange="openChangeOne"
                      @panelChange="panelChangeOne"
                  />
            </a-col>

            <a-col :md="8" :sm="12" :xs="24">
              <span
                  class="table-page-search-submitButtons">
                <a-button type="danger" @click="getList()">查询</a-button>
                <a-button style="margin-left: 8px" @click="restQuery()">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      <div class="tj">
        <span>用户：<span v-if="userInfo && userInfo.fullName">{{userInfo.fullName}}</span></span>
        <span>工号：<span  v-if="userInfo && userInfo.jdUserCode">{{userInfo.jdUserCode}}</span></span>
      </div>
        <div class="tj">
          <span>集中培训和集体学时：{{dataSum.pxxs}}</span>
          <span>网络自学：{{dataSum.wlxs}}</span>
        </div>
      </div>

    <div class="funbut">
      <a-button type="danger" @click="add">添加</a-button>
      <a-button icon="cloud-download" @click="template()" >模板下载</a-button>
      <a-upload
          name="file"
          :showUploadList="false"
          :customRequest="handleImport"
      >
        <a-button :icon="fileLoading ? 'loading' : 'upload'">导入</a-button>
      </a-upload>
    </div>

    <a-table
        ref="workProcedureInfoTable"
        size="default"
        class="newtable"
        :rowKey="(recordActive) => recordActive.id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
    >

      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleUpdate(record)" >编辑</a>
          <a style="margin-left:10px" @click="handleDetail(record)" >详情</a>
                  <a-popconfirm title="您确认删除吗?" @confirm="handleDelete(record.id)" okText="确认" cancelText="取消">
            <a style="margin-left:10px" href="javascript:void(0)">删除</a>
          </a-popconfirm>

        </template>
      </span>

      <span slot="strTime" slot-scope="text, row">
          <template>
          {{extractYMD(row.strTime)}} - {{extractYMD(row.endTime)}}
          </template>
      </span>

    </a-table>
</div>
    <a-pagination
        :total="pagination.total"
        :current="pagination.current"
        :pageSize="pagination.pageSize"
        :showSizeChanger="true"
        @change="handlePageChange"
    ></a-pagination>
    <add-and-edit ref="add" :refresh="restQuery" />
    <detail ref="detail"  />

  </a-card>
</template>

<script>
import 'ant-design-vue/es/message/style/css'; // 引入 Message 组件的样式
import {del, getUserInfo, getXsSum, importExcel, queryList, template} from "../../api/educationalTraining";
import 'ant-design-vue/dist/antd.css';
import {Card, Form, Row, Col, DatePicker, Button, Table, Upload, Pagination, Popconfirm,} from 'ant-design-vue';
import addAndEdit from "./components/addAndEdit.vue";
import detail from "./components/detail.vue";
import moment from "moment/moment";
import Message from "ant-design-vue/lib/message";
export default {
  components: {
    addAndEdit,
    detail,
    'a-card': Card,
    'a-popconfirm': Popconfirm,
    'a-form': Form,
    'a-row': Row,
    'a-date-picker': DatePicker,
    'a-col': Col,
    'a-button': Button,
    'a-table': Table,
    'a-pagination': Pagination,
    'a-upload': Upload,
  },
  data () {
    return {
      Message,
      yearShowOne: false,
      fileLoading: false,
      pagination: {
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        current: 1, // 当前页数
        showSizeChanger: true,
        pageSizeOptions: ['10'], // 每页中显示的数据
      },
      list:[],
      // 查询参数
      queryParams:{year:moment( new Date()).format('YYYY')},
      // 列表表头
      columns: [
        {
          title: '序号',
          // 使用 customRender 来自定义序号
          customRender: (text, record, index) => {
            return index + 1; // 自增的序号，从 1 开始
          },
        },
        {
          title: '姓名',
          dataIndex: 'fullName',
          key: 'fullName'
        },
        {
          title: '教育培训内容',
          dataIndex: 'remark',
          key: 'remark'
        },
        {
          title: '主办单位',
          dataIndex: 'organizeName',
          key: 'organizeName'
        },
        // {
        //   title: '培训层级',
        //   dataIndex: 'pxcj',
        //   key: 'pxcj'
        // },
        {
          title: '教育培训时间',
          dataIndex: 'strTime',
          key: 'strTime',
          scopedSlots: { customRender: 'strTime' }
        },
        {
          title: '集中培训和集体学习学时数',
          dataIndex: 'pxxs',
          key: 'pxxs',
          width: '100px',
        },
        {
          title: '网络自学培训学时',
          dataIndex: 'wlxs',
          key: 'wlxs',
          width: '100px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      noticeTypeOptions: [],
      noticeOptions: [],
      noticeStatusOptions: [],
      dataSum:{},
      userInfo:{},
      // 单个记录行
      recordActive: {}
    }
  },
  created () {
    this.getList()
    getUserInfo().then(res =>{
      if (res.code === 10000){
        this.userInfo = res.result
      }
    })
  },
  computed: {},
  methods: {
    extractYMD(dateString) {
      // 先将日期字符串转换为 Date 对象
      const date = new Date(dateString.replace(' ', 'T')); // 替换空格为 'T'，确保能被解析为有效的 ISO 格式
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并格式化为两位数
      const day = String(date.getDate()).padStart(2, '0'); // 保证天数是两位数
      return `${year}-${month}-${day}`;
    },
    add(){
      this.$refs.add.show()
    },
    handleUpdate(record){
      this.$refs.add.show(record.id)
    },
    handleDetail(record){
      this.$refs.detail.show(record.id)
    },
    getList(){
      queryList(Object.assign(this.pagination, this.queryParams))
          .then(res => {
            if (res.code === 10000) {
              this.list = res.result.records
              this.pagination.total =res.result.total
            }
          })

      getXsSum().then(res =>{
        if (res.code  === 10000){
          this.dataSum = res.result

        }
      })

    },
    handlePageChange(page, pageSize) {
      // 更新当前页数
      this.pagination.current = page;
      this.pagination.pageSize = pageSize;

      // 更新查询参数中的页数
      this.queryParams.page = page;
      this.queryParams.pageSize = pageSize;

      // 重新获取数据
      this.getList();
    },

    // 删除记录
    handleDelete (id) {
      del({ id: id }).then(res => {
        if (res.code === 10000) {
          Message.success('操作成功');
          this.restQuery()
        }
      })
    },

    /**
     * 导入
     */
    handleImport (data) {
      this.fileLoading = true
      importExcel(data.file).then(res => {
        if (res.code === 10000) {
          Message.success(res.result);

        }
      }).finally(() => {
        this.fileLoading = false
        this.getList()
      })
    },


    template(){
      template().then(res =>{
        if (res.code === 10000){
          Message.success(res.result);
        }
      })
    },
    // 弹出日历和关闭日历的回调
    openChangeOne (status) {
      // status是打开或关闭的状态
      if (status) {
        this.yearShowOne = true
      }
    },
// 得到年份选择器的值
    panelChangeOne (value) {
      this.queryParams.year = value
      this.yearShowOne = false
    },
    // 选择框搜索过滤
    filterOption (input, option) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) > -1)
    },
    // 重置查询
    restQuery () {
      this.pagination.current = 1;
      this.queryParams.year  = moment( new Date()).format('YYYY')
      this.getList()

    },


  }
}
</script>
<style scoped>
/deep/.ant-card-body{
  padding: 0;
  margin: 0;
}
.top{
  width: 100%;
  height:76px;
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 666;
}
.head{
  width: 1170px;
  margin: 0 auto;
  height:76px;
}
.head h1{
  float: left;
  position: relative;
  top:7px;
}
.head h1 img{
  width: 233px;
}
.topimg{
  display: flex;
  width: 100%;
  height: 300px;
  background: #000000;
}
.newbox{
  display: flex;
  flex-direction: column;
  width: 1170px;
  background: #FFFFFF;
  box-shadow: 0px 8px 40px 0px rgba(0,38,115,0.08);
  border-radius: 10px;
  padding: 15px 0;
  position: relative;
  box-sizing: border-box;
  margin: 15px auto;
}
.search{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px 15px 15px;
  border-bottom: 1px solid #dedede;
  margin-bottom: 15px;
}
.nantrow  {
  display: flex;
  align-items: center;
  flex: 1;
}
.ncol{
  display: flex;
  align-items: center;
  width: 400px;
}
.tj span{
  font-weight: bold;
  margin-left: 25px;
}
.funbut{
  display: flex;
  align-items: center;
  padding: 0 15px;
  margin-bottom: 15px;
}
.funbut button{
  margin: 0 10px;
}
.newtable{
  border: 1px solid #dedede;
  margin: 0 25px;
  border-radius: 8px;
  overflow: hidden;
}
/deep/.ant-pagination{
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
}
</style>
